module.exports = __webpack_public_path__ + "images/kihnu/routes/SVI-ROH-SVI.png";